import { FlowGrid, Paragraph, Separator } from '@fs/zion-ui'
import React from 'react'
import FilterInput from '../../FilterInput'

/**
 * Displays a section with a description paragraph and a filter input for searching persons by name.
 *
 * @component
 * @param {Object} props
 * @param {string} props.filterValue - Current filter text value
 * @param {string} props.description - Description text to display above the filter
 * @param {Function} props.onFilterChange - Callback when filter value changes
 * @returns {JSX.Element}
 */
const FilterAndActions = ({ filterValue, description, onFilterChange }) => {
  return (
    <>
      <Separator size="xs" />
      <FlowGrid columnCount={1} orientation="vertical" guttersY="xxs">
        <Paragraph size="sm">{description}</Paragraph>
        <FilterInput filterValue={filterValue} onFilterChange={onFilterChange} textFieldProps={{ dense: true }} />
      </FlowGrid>
    </>
  )
}

export default FilterAndActions
